import { z } from 'zod';

export const FeaturesSchema = z.object({
    single_scans: z.object({}).optional(),
    deep_scans: z.object({
        maxCredits: z.coerce.number(),
        meter: z.array(z.enum(['starterAudits', 'credits'])).default(['starterAudits', 'credits'])
    }).optional(),
    monitoring: z.object({}).optional(),
    pdf_reports: z.object({}).optional(),
    multi_user: z.object({}).optional(),
    customer_management: z.object({}).optional(),
    api_access: z.object({}).optional()
});

export type Features = z.infer<typeof FeaturesSchema>;
export type Feature = keyof Features;

export type ConditionalFeature<F> = F extends Feature ? {
    key: F,
    condition: (options: NonNullable<Features[F]>) => boolean
} : never;
export type MaybeConditionalFeature<F extends Feature = Feature> = F | ConditionalFeature<F>;
